import { BASE_URL } from "../config/config";

// Like Channel
export const likeChannel = async (channelId) => {
    try {
        const response = await fetch(`${BASE_URL}/channels/${channelId}/like`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.ok;
    } catch (error) {
        console.error("Error liking channel:", error);
        return false;
    }
};

// Dislike Channel
export const dislikeChannel = async (channelId) => {
    try {
        const response = await fetch(`${BASE_URL}/channels/${channelId}/dislike`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.ok;
    } catch (error) {
        console.error("Error disliking channel:", error);
        return false;
    }
};

// Favorite Channel
export const favoriteChannel = async (channelId) => {
    try {
        const response = await fetch(`${BASE_URL}/channels/${channelId}/favorite`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        });
        return response.ok;
    } catch (error) {
        console.error("Error favoriting channel:", error);
        return false;
    }
};